import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../api/api';


@Injectable()
export class Repository {

  constructor(public api: Api) { }

  getBerita(params){
    let seq = this.api.postCustomUrl('https://support.appsradiant.com/api/index.php/service_library/'+params.controller,params);
    return seq;
  }

  getMyOrganization(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/myOrganization',params);
    return req;
  }

  addVisitors(params?:any){
    let seq = this.api.postCustomUrl('https://support.appsradiant.com/api/index.php/service_library/SRV0095',params);
    return seq;
  }

  getVisitors(params?:any){
    let seq = this.api.postCustomUrl('https://support.appsradiant.com/api/index.php/service_library/SRV0103',params);
    return seq;
  }

  getRuningText(params){
    let seq = this.api.postCustomUrl('https://support.appsradiant.com/api/index.php/service_library/SRV0055',params);
    return seq;
  }

  getMyUnitBoard(params){
    let seq = this.api.postCustomUrl('https://support.appsradiant.com/api/index.php/service_library/SRV0071',params);
    return seq;
  }


  getProfilGeneral(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/general',params);
    return req;
  }

  getProfilFamily(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/family',params);
    return req;
  }

  getProfilNotes(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/notes',params);
    return req;
  }

  getProfilMedical(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/mcu',params);
    return req;
  }

  getProfilInsurance(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/insurance',params);
    return req;
  }

  getProfilCeritificate(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/certificate',params);
    return req;
  }

  getProfilAssets(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/assets',params);
    return req;
  }

  getProfilAdvance(params?:any){
    // let req = this.api.get('index.php/advance/advance',params);
    let req = this.api.get('index.php/myradiant/Profil/advance',params);
    return req;
  }
  
  getProfilProject(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/project',params);
    return req;
  }

  getProfilTicket(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/ticket',params);
    return req;
  }

  getProfilHotel(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/hotel',params);
    return req;
  }

  getProfilFI(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/fieldInstruction',params);
    return req;
  }

  getProfilPresensi(params?:any){
    let seq = this.api.postCustomUrl(this.api.url_erp+'/SRV0090?token='+params.token+'&Employee='+params.id,{});
    return seq;
  }

  getListPresensiDetail(params?:any){
    let seq = this.api.postCustomUrl(this.api.url_erp+'/SRV0093?token='+params.token+'&Employee='+params.id+'&Month='+params.month,{});
    return seq;
  }

  getRequestAproval(params?:any){
    let req = this.api.get('index.php/myradiant/Aproval/index',params);
    return req;
  }


  /* Presensi */
  getListAttendance(params?:any){
    let req = this.api.get('index.php/presensi/Attendance/index',params);
    return req;
  }

  getListLeave(params?:any){
    let req = this.api.get('index.php/presensi/Leave/index',params);
    return req;
  }

  getListPermit(params?:any){
    let req = this.api.get('index.php/presensi/Permit/index',params);
    return req;
  }

  getListOvertime(params?:any){
    let req = this.api.get('index.php/presensi/Overtime/index',params);
    return req;
  }

  getListOvertimeBawahan(params?:any){
    let req = this.api.get('index.php/presensi/Overtime/overtimeBawahan',params);
    return req;
  }
  
  getBawahan(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/search_pegawai',params);
    return req;
  }

  checkBeforeGetBawahan(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/checkBeforeGetBawahan',params);
    return req;
  }

  childrenMyOrganization(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/childrenMyOrganization',params);
    return req;
  }
  
  getBawahanFromTree(params?:any){
    let req = this.api.get('index.php/myradiant/Profil/bawahanFromTree',params);
    return req;
  }

  getListPermitType(params?:any){
    let req = this.api.get('index.php/presensi/Permit/listType',params);
    return req;
  }

  getListPermitBawahan(params?:any){
    let req = this.api.get('index.php/presensi/Permit/permitBawahan',params);
    return req;
  }

  getCutiAlokasi(params?:any){
    let req = this.api.get('index.php/presensi/Permit/cutiAlokasi',params);
    return req;
  }

  // Activity
  getListActivity(params?:any){
    let req = this.api.get('index.php/activity/App/activity',params);
    return req;
  }
  getDailyActivity(params?:any){
    let req = this.api.get('index.php/activity/App/dailyActivity',params);
    return req;
  }
  getListActivityBawahan(params?:any){
    let req = this.api.get('index.php/activity/App/activityBawahan',params);
    return req;
  }


  //Options
  getListReligion(){
    let req = this.api.get('index.php/myradiant/Simplelist/religion');
    return req;
  }

  getListModul(){
    let req = this.api.get('index.php/myradiant/Simplelist/modul');
    return req;
  }

  getListRelationship(){
    let req = this.api.get('index.php/myradiant/Simplelist/relationshipFamily');
    return req;
  }

  getListCity(){
    let req = this.api.get('index.php/myradiant/Simplelist/cityList');
    return req;
  }



  //general 
  getAppVersion(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/AppVersion',params);
    return req;
  }

  getDepartment(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/departmentList');
    return req;
  }

  getListFAQ(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/FAQList',params);
    return req;
  }
  getStatusMCU(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/listStatusMCU',params);
    return req;
  }
  getTypeMCU(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/listTypeMCU',params);
    return req;
  }
  getPaketMCU(params?:any){
    let req = this.api.get('index.php/myradiant/Simplelist/listPaketMCU',params);
    return req;
  }
}



// WEBPACK FOOTER //
// ./src/providers/resources/repository.ts